module.exports = __webpack_public_path__ + "img/guide-wrap-bg.83da1e85.png";